export default "__VITE_ASSET__160896af__"